import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const DATABASE_IN_APP_PRODUCTS = "https://chat-murcianys-18752.firebaseio.com/";
const DATABASE_IN_APP_PURCHASES =
  "https://chat-murcianys-efb7f.firebaseio.com/";

const firebaseConfig = {
  apiKey: "AIzaSyCss8833TpaKYlIrRsC_VkrxKQC-Uuf_nI",
  authDomain: "chat-murcianys.firebaseapp.com",
  databaseURL: "https://chat-murcianys.firebaseio.com",
  projectId: "chat-murcianys",
  storageBucket: "chat-murcianys.appspot.com",
  messagingSenderId: "484066067543",
  appId: "1:484066067543:web:b12e176ab6ad132a0e8f12",
};

// 1. Initialize Firebase app immediately
export const app = initializeApp(firebaseConfig);

// 2. Initialize and export your databases directly
export const dbApp = getDatabase(app);
export const dbProducts = getDatabase(app, DATABASE_IN_APP_PRODUCTS);

// Keep an empty initConfig function so your index.js file doesn't crash from a missing import
export function initConfig() {
  // Safe to leave empty now
}
